import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// React Router matches "/contact" and "/contact/" as the same route, but links
// and ad-driven traffic don't always agree on the trailing slash — strip it
// before comparing paths so route-matching checks don't miss on that alone.
export function stripTrailingSlash(pathname) {
  return pathname.replace(/\/+$/, '');
}
